import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { ReservationPolicy as ReservationPolicyType } from '../../../../types/policy';
import ReservationPolicy from './ReservationPolicy';

const ReservationPolicies = () => {
    const { control } = useFormContext();

    const policy = useWatch({ control, name: 'policy' });

    return (
        <Box sx={{ mt: { xs: 2, sm: 3 } }}>
            <Stack>
                <Typography
                    variant='body1'
                    sx={{
                        fontWeight: 'bold',
                    }}
                    gutterBottom
                >
                    Reservation Policies
                </Typography>
                {policy ? (
                    <Typography variant='body3' fontWeight={550} gutterBottom>
                        The host of this property requires guests to acknowledge
                        and accept the following policy before confirming the
                        reservation.
                    </Typography>
                ) : (
                    <Typography variant='body3' fontWeight={550} gutterBottom>
                        The following cancellation policy aapplies to this
                        experience when the booking has been confirmed:
                    </Typography>
                )}
            </Stack>
            <ReservationPolicy policy={policy} control={control} />
        </Box>
    );
};

export default ReservationPolicies;
